export { actionClick } from './action-click';
export { getEditProject } from './get-edit-project';
export { setEditMode } from './set-edit-mode';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/actions/project-actions/index.ts